package com.cybergstudios.rtc.engine

/**
 * The canvas dimensions described with originX and originY at the center of the canvas.
 * Our game has 600x750 canvas.
 */
data class CanvasDimension(
    val originX: Double,
    val originY: Double,
    val borderMaxX: Double,
    val borderMinX: Double,
    val borderTop: Double,
    val borderBottom: Double,
)
